import React from "react";
import { makeStyles } from '@material-ui/core/styles'
import classnames from "classnames";
import ButtonBase from "@material-ui/core/ButtonBase";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  card: {
    height: 100,
    width: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.background.paper,

    "&.selected": {
      border: `2px solid ${theme.palette.primary.main}`
    },

    "&.disabled": {
      backgroundColor: theme.palette.grey['200']
    }
  }
}));

const Card: React.FC<{
  label: string;
  selected: boolean;
  disabled: boolean;
  onClick: () => void
}> = ({ label, selected, disabled, onClick }) => {
  const classes = useStyles();

  return(
    <ButtonBase onClick={onClick} disabled={disabled}>
      <Paper elevation={2} className={classnames(classes.card, { selected, disabled })}>
        <Typography variant="h4">{label}</Typography>
      </Paper>
    </ButtonBase>
  );
}

export default Card;